(function () {
  var DATA = {
    "instantnudeln-ramen": {
      title: 'Instantnudeln <span class="toa-amp">&amp;</span> Ramen',
      text: "Schnell, lecker und vielseitig: Entdecke Instantnudeln und Ramen aus Asien - von mild bis feurig scharf.",
      chips: ["Korea", "Japan", "Scharf", "Vegetarisch", "Cup Noodles", "Bestseller"],
      min: "ab 0,59 &euro;",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-instantnudeln-ramen-20260528.jpg"
    },
    "mehl": {
      title: "Mehl",
      text: "Vielfalt f&uuml;r authentische asiatische K&uuml;che: Mehle und St&auml;rken f&uuml;r Teige, Desserts, Panaden und mehr.",
      chips: ["Reismehl", "Tapioka", "Klebreismehl", "Kichererbsenmehl", "St&auml;rke", "Bestseller"],
      min: "ab 0,79 &euro;",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-mehl-20260528.jpg"
    },
    "reisprodukte": {
      title: "Reisprodukte",
      text: "Reispapier, Mochi, Reiscracker und Reiskuchen: alles rund um Reisprodukte f&uuml;r K&uuml;che, Snacks und Desserts.",
      chips: ["Reispapier", "Mochi", "Reiscracker", "Reiskuchen", "Puffreis", "Bestseller"],
      min: "ab 0,99 &euro;",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-reisprodukte-20260528.jpg"
    },
    "hulsenfruchte": {
      title: "H&uuml;lsenfr&uuml;chte",
      text: "Linsen, Bohnen und weitere H&uuml;lsenfr&uuml;chte: n&auml;hrstoffreich, vielseitig und unverzichtbar in der asiatischen K&uuml;che.",
      chips: ["Linsen", "Bohnen", "Mungbohnen", "Kichererbsen", "Adzukibohnen", "Bestseller"],
      min: "ab 0,79 &euro;",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-hulsenfruchte-20260528.jpg"
    },
    "nudeln": {
      title: "Nudeln",
      text: "Asiatische Nudeln von zarten Reisnudeln &uuml;ber Udon bis zu aromatischen Eiernudeln f&uuml;r Suppen, Wokgerichte und Lieblingsrezepte.",
      chips: ["Reisnudeln", "Udon", "Soba", "Glasnudeln", "Eiernudeln", "Bestseller"],
      min: "ab 0,59 &euro;",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-nudeln-20260528.jpg"
    },
    "reisi": {
      title: "Reis",
      text: "Jasminreis, Basmati, Sushi-Reis und Klebreis: passende Reissorten f&uuml;r jeden Tag und viele asiatische K&uuml;chen.",
      chips: ["Jasmin", "Basmati", "Sushi-Reis", "Klebreis", "Vorratspackung", "Bestseller"],
      min: "ab 0,89 &euro;",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-reisi-20260528.jpg"
    },
    "alle-produkte": {
      title: "Alle Produkte",
      text: "Entdecke unser komplettes Asia-Sortiment: Reis, Nudeln, Saucen, Gew&uuml;rze, Snacks, Getr&auml;nke und Spezialit&auml;ten f&uuml;r deine K&uuml;che.",
      alt: "Alle Produkte Hero Banner mit asiatischen Lebensmitteln, Saucen, Reis, Nudeln und Gewuerzen",
      min: "ab 0,29 &euro;",
      factTitle: "Gro&szlig;es Sortiment",
      factText: "Asia-Basics, Snacks &amp; Spezialit&auml;ten",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-alle-produkte-20260726.png"
    },
    "all": {
      title: "Alle Produkte",
      text: "Entdecke unser komplettes Asia-Sortiment: Reis, Nudeln, Saucen, Gew&uuml;rze, Snacks, Getr&auml;nke und Spezialit&auml;ten f&uuml;r deine K&uuml;che.",
      alt: "Alle Produkte Hero Banner mit asiatischen Lebensmitteln, Saucen, Reis, Nudeln und Gewuerzen",
      min: "ab 0,29 &euro;",
      factTitle: "Gro&szlig;es Sortiment",
      factText: "Asia-Basics, Snacks &amp; Spezialit&auml;ten",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-alle-produkte-20260726.png"
    },
    "sale": {
      title: "Angebote",
      text: "Aktuelle Deals und reduzierte Asia-Produkte: entdecke ausgew&auml;hlte Lebensmittel, Snacks, Saucen und Vorratsartikel zum Vorteilspreis.",
      alt: "Angebote Hero Banner mit reduzierten asiatischen Lebensmitteln, Ramen, Reis, Saucen und Snacks",
      min: "Reduziert",
      priceLabel: "sparen",
      factTitle: "Nur kurze Zeit",
      factText: "ausgew&auml;hlte Angebote",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-angebote-20260726.png"
    },
    "angebote": {
      title: "Angebote",
      text: "Aktuelle Deals und reduzierte Asia-Produkte: entdecke ausgew&auml;hlte Lebensmittel, Snacks, Saucen und Vorratsartikel zum Vorteilspreis.",
      alt: "Angebote Hero Banner mit reduzierten asiatischen Lebensmitteln, Ramen, Reis, Saucen und Snacks",
      min: "Reduziert",
      priceLabel: "sparen",
      factTitle: "Nur kurze Zeit",
      factText: "ausgew&auml;hlte Angebote",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-angebote-20260726.png"
    },
    "neu-im-shop": {
      title: "Neu im Sortiment",
      text: "Frisch eingetroffene Asia-Produkte: neue Snacks, Nudeln, Saucen, Getr&auml;nke und Regalfunde, die gerade neu bei Taste of Asia online sind.",
      alt: "Neu im Sortiment Hero Banner mit neuen asiatischen Lebensmitteln, Ramen, Mochi, Saucen und Snacks",
      min: "Frisch rein",
      priceLabel: "aktuell",
      factTitle: "Regelm&auml;&szlig;ig aktualisiert",
      factText: "neue Regalfunde",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-neu-im-sortiment-20260726.png"
    },
    "neu-im-sortiment": {
      title: "Neu im Sortiment",
      text: "Frisch eingetroffene Asia-Produkte: neue Snacks, Nudeln, Saucen, Getr&auml;nke und Regalfunde, die gerade neu bei Taste of Asia online sind.",
      alt: "Neu im Sortiment Hero Banner mit neuen asiatischen Lebensmitteln, Ramen, Mochi, Saucen und Snacks",
      min: "Frisch rein",
      priceLabel: "aktuell",
      factTitle: "Regelm&auml;&szlig;ig aktualisiert",
      factText: "neue Regalfunde",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-neu-im-sortiment-20260726.png"
    },
    "korea": {
      title: "Korea",
      text: "Koreanische Klassiker von Ramen und Kimchi bis Gochujang, Reiskuchen und Snacks.",
      alt: "Korea Hero Banner mit Ramen, Kimchi und koreanischen Klassikern",
      min: "ab 0,59 &euro;",
      factTitle: "W&uuml;rzig &amp; beliebt",
      factText: "Ramen, Kimchi &amp; Gochujang",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-korea-photo-20260726.png"
    },
    "japan": {
      title: "Japan",
      text: "Feine Zutaten f&uuml;r Ramen, Sushi und japanische Alltagsk&uuml;che.",
      alt: "Japan Hero Banner mit Ramen, Sojasauce und japanischen Zutaten",
      min: "ab 0,79 &euro;",
      factTitle: "F&uuml;r Ramen &amp; Sushi",
      factText: "Miso, Mochi &amp; Saucen",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-japan-photo-20260726.png"
    },
    "thailand": {
      title: "Thailand",
      text: "Originale Zutaten f&uuml;r Currys, Wokgerichte und Suppen.",
      alt: "Thailand Hero Banner mit Thai Curry, Kokosmilch und Currypaste",
      min: "ab 0,79 &euro;",
      factTitle: "F&uuml;r Curry &amp; Wok",
      factText: "Kokos, Chili &amp; Kr&auml;uter",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-thailand-photo-20260726.png"
    },
    "china": {
      title: "China",
      text: "Chinesische Lebensmittel f&uuml;r Nudeln, Saucen, Gew&uuml;rze, Dumplings und Spezialit&auml;ten.",
      alt: "China Hero Banner mit Sojasauce, Nudeln und chinesischen Spezialitaeten",
      min: "ab 0,79 &euro;",
      factTitle: "F&uuml;r Wok &amp; Dumplings",
      factText: "Saucen, Nudeln &amp; Gew&uuml;rze",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-china-photo-20260726.png"
    },
    "indien": {
      title: "Indien",
      text: "Aromatische Gew&uuml;rze, Currys, Reis, Linsen und Chutneys.",
      alt: "Indien Hero Banner mit Basmati Reis, Tikka Masala und indischen Gewuerzen",
      min: "ab 0,79 &euro;",
      factTitle: "F&uuml;r Curry &amp; Reis",
      factText: "Masalas, Dal &amp; Chutneys",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-indien-photo-20260726.png"
    },
    "bestseller": {
      title: "Bestseller",
      text: "Die beliebtesten Produkte unserer Kundinnen und Kunden.",
      alt: "Bestseller Hero Banner mit beliebten Asia-Produkten",
      min: "Bew&auml;hrt",
      priceLabel: "&amp; beliebt",
      factTitle: "Oft gekauft",
      factText: "Favoriten aus dem Shop",
      img: "/cdn/shop/t/2/assets/toa-collection-hero-bestseller-photo-20260726.png"
    }
  };

  function addStyle() {
    if (document.getElementById("toa-collection-hero-style")) return;
    var css = ".toa-collection-hero-wrap{margin:0 0 22px}.collection-breadcrumb--above{margin-top:20px!important;margin-bottom:14px!important}.toa-collection-hero{position:relative;overflow:hidden;min-height:350px;border:1px solid #eadbc1;border-radius:18px;background:#fff8eb;box-shadow:0 14px 32px rgba(44,31,10,.08)}.toa-collection-hero__image{position:absolute;inset:0 0 0 39%;background-size:cover;background-position:center right;filter:saturate(1.03)}.toa-collection-hero__image:before{content:\"\";position:absolute;inset:0;background:linear-gradient(90deg,#fff8eb 0%,rgba(255,248,235,.97) 18%,rgba(255,248,235,.7) 46%,rgba(255,248,235,.15) 72%,rgba(255,248,235,0) 100%)}.toa-collection-hero__content{position:relative;z-index:1;width:min(760px,60%);padding:34px 42px 30px}.toa-collection-hero__eyebrow{font:800 12px/1.2 Arial,sans-serif;letter-spacing:.04em;text-transform:uppercase;color:#cf352e;margin-bottom:10px}.toa-collection-hero h1{font-family:Georgia,'Times New Roman',serif;font-size:clamp(40px,4.2vw,58px);line-height:1.02;margin:0 0 14px;color:#123f24;letter-spacing:0}.toa-amp{display:inline-block;font-family:Arial,sans-serif;font-size:.72em;font-weight:800;margin:0 .08em;transform:translateY(-.04em)}.toa-collection-hero__text{max-width:600px;margin:0 0 16px;color:#4e5d4f;font-size:16px;line-height:1.38;font-weight:600}.toa-collection-hero__chips{display:none!important}.toa-collection-hero__facts{display:flex;gap:10px;flex-wrap:wrap}.toa-collection-hero__fact{display:flex;align-items:center;gap:12px;min-width:138px;padding:11px 14px;border:1px solid #eadbc1;border-radius:10px;background:rgba(255,255,255,.82);box-shadow:0 6px 16px rgba(44,31,10,.06)}.toa-collection-hero__fact-icon{width:42px;height:42px;display:grid;place-items:center;flex:0 0 42px;color:#18281d}.toa-collection-hero__fact-icon svg{display:block;width:38px;height:38px;stroke:currentColor;fill:none;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}.toa-collection-hero__fact strong{display:block;color:#18281d;font-size:15px;line-height:1.05}.toa-collection-hero__fact span{display:block;color:#6b7469;font-size:11px;margin-top:3px}@media (max-width:989px){.toa-collection-hero{min-height:auto;border-radius:14px}.toa-collection-hero__image{position:relative;inset:auto;width:100%;height:190px;background-position:center}.toa-collection-hero__image:before{background:linear-gradient(180deg,rgba(255,248,235,0),#fff8eb)}.toa-collection-hero__content{width:100%;padding:24px 22px 26px}.toa-collection-hero h1{font-size:42px}.toa-collection-hero__text{font-size:16px}.toa-collection-hero__fact{flex:1 1 100%;min-width:0}}@media (max-width:520px){.toa-collection-hero-wrap{margin:0 0 18px}.toa-collection-hero__image{height:145px}.toa-collection-hero h1{font-size:34px}.toa-collection-hero__content{padding:20px 16px 22px}.toa-collection-hero__fact strong{font-size:15px}}";
    css += ".toa-collection-hero--banner{min-height:auto;border:0;background:transparent;box-shadow:none}.toa-collection-hero__banner-img{display:block;width:100%;height:auto;border:1px solid #eadbc1;border-radius:18px;box-shadow:0 14px 32px rgba(44,31,10,.08)}.toa-collection-hero__sr{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}@media (max-width:520px){.toa-collection-hero__banner-img{border-radius:14px}}";
    var style = document.createElement("style");
    style.id = "toa-collection-hero-style";
    style.textContent = css;
    document.head.appendChild(style);
  }

  function handleFromPath() {
    var match = location.pathname.match(/\/collections\/([^/?#]+)/);
    var handle = match ? decodeURIComponent(match[1]) : "";
    if ((handle === "alle-produkte" || handle === "all") && location.search.indexOf("sort_by=best-selling") !== -1) {
      return "bestseller";
    }
    return handle;
  }

  function stripTags(value) {
    return String(value == null ? "" : value).replace(/<[^>]+>/g, "");
  }

  function escapeAttr(value) {
    return stripTags(value).replace(/[&<>"']/g, function (char) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
    });
  }

  function productCount(fallback) {
    var text = document.body ? document.body.innerText : "";
    var m = text.match(/(^|[^\d.,])(\d{1,4})\s+Produkte\b/);
    return m ? m[2] : fallback;
  }

  function factIcon(type) {
    var icons = {
      products: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M10 25h28c-1.4 9-6.4 14-14 14S11.4 34 10 25Z"/><path d="M14 22c3-5 17-5 20 0"/><path d="M14 12c-2-3 3-4 1-7M24 12c-2-3 3-4 1-7M34 12c-2-3 3-4 1-7"/></svg>',
      price: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M8 24 24 8h14v14L22 38 8 24Z"/><circle cx="32" cy="16" r="2.5"/></svg>',
      shipping: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M7 14h23v20H7z"/><path d="M30 21h7l5 6v7H30z"/><circle cx="16" cy="37" r="3.5"/><circle cx="36" cy="37" r="3.5"/></svg>'
    };
    return icons[type] || "";
  }

  function formatPrice(value) {
    var price = Number(value);
    if (!isFinite(price)) return "";
    return "ab " + price.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " \u20ac";
  }

  async function updateHeroFacts(handle) {
    var hero = document.querySelector('[data-toa-collection-hero="' + handle + '"]');
    if (!hero || !window.fetch) return;
    if (handle === "bestseller" || handle === "alle-produkte" || handle === "all" || handle === "sale" || handle === "angebote" || handle === "neu-im-shop" || handle === "neu-im-sortiment") return;
    var min = Infinity;
    var total = 0;
    try {
      for (var page = 1; page <= 12; page += 1) {
        var jsonHandle = handle === "bestseller" ? "alle-produkte" : handle;
        var response = await fetch("/collections/" + encodeURIComponent(jsonHandle) + "/products.json?limit=250&page=" + page, { cache: "no-store" });
        if (!response.ok) break;
        var payload = await response.json();
        var products = payload.products || [];
        total += products.length;
        products.forEach(function (product) {
          (product.variants || []).forEach(function (variant) {
            if (variant.available === false) return;
            var price = Number(variant.price);
            if (isFinite(price) && price > 0 && price < min) min = price;
          });
        });
        if (products.length < 250) break;
      }
    } catch (error) {
      return;
    }
    var countEl = hero.querySelector(".toa-collection-hero__product-count");
    if (countEl && total > 0) countEl.textContent = String(total);
    var priceEl = hero.querySelector(".toa-collection-hero__min-price");
    if (priceEl && isFinite(min)) priceEl.textContent = formatPrice(min);
  }

  function render(handle, data) {
    addStyle();
    var oldHeader = document.querySelector(".collection-header");
    var existing = document.querySelector("[data-toa-collection-hero]");
    if (existing) {
      if (oldHeader) oldHeader.style.display = "none";
      updateHeroFacts(handle);
      return;
    }
    var target = oldHeader || document.querySelector(".collection-page .container > .collection-breadcrumb") || document.querySelector(".collection-page .container");
    if (!target || !target.parentNode) return;
    if (oldHeader) oldHeader.style.display = "none";
    var count = productCount("Viele");
    var label = escapeAttr(data.title);
    var html;
    if (data.mode === "banner") {
      html = '<div class="toa-collection-hero-wrap" data-toa-collection-hero="' + handle + '">' +
        '<section class="toa-collection-hero toa-collection-hero--banner toa-collection-hero--' + handle + '" aria-label="' + label + '">' +
        '<img class="toa-collection-hero__banner-img" src="' + data.img + '" alt="' + escapeAttr(data.alt || data.title) + '" title="' + escapeAttr(data.alt || data.title) + '" loading="eager" decoding="async">' +
        '<div class="toa-collection-hero__sr"><h1>' + data.title + '</h1><p>' + data.text + '</p></div>' +
        "</section></div>";
    } else {
      html = '<div class="toa-collection-hero-wrap" data-toa-collection-hero="' + handle + '">' +
      '<section class="toa-collection-hero toa-collection-hero--' + handle + '" aria-label="' + label + '">' +
      '<div class="toa-collection-hero__image" role="img" aria-label="' + escapeAttr(data.alt || data.title) + '" style="background-image:url(' + data.img + ');"></div>' +
      '<div class="toa-collection-hero__content">' +
      '<div class="toa-collection-hero__eyebrow">Kategorie entdecken</div>' +
      "<h1>" + data.title + "</h1>" +
      '<p class="toa-collection-hero__text">' + data.text + "</p>" +
      '<div class="toa-collection-hero__facts">' +
      '<div class="toa-collection-hero__fact"><span class="toa-collection-hero__fact-icon">' + factIcon("products") + '</span><div><strong class="toa-collection-hero__product-count">' + count + '</strong><span>Produkte</span></div></div>' +
      '<div class="toa-collection-hero__fact"><span class="toa-collection-hero__fact-icon">' + factIcon("price") + '</span><div><strong class="toa-collection-hero__min-price">' + data.min + '</strong><span>' + (data.priceLabel || "Beste Preise") + '</span></div></div>' +
      '<div class="toa-collection-hero__fact"><span class="toa-collection-hero__fact-icon">' + factIcon(data.factIcon || "products") + '</span><div><strong>' + (data.factTitle || "Schneller Versand") + '</strong><span>' + (data.factText || "ab 49 &euro; versandkostenfrei") + '</span></div></div>' +
      "</div></div></section></div>";
    }
    var node = document.createElement("div");
    node.innerHTML = html;
    target.parentNode.insertBefore(node.firstChild, target);
    if (data.mode !== "banner") updateHeroFacts(handle);
  }

  function repairExistingHeroAmpersand(hero) {
    var heading = hero && hero.querySelector("h1");
    if (!heading || heading.querySelector(".toa-amp")) return;
    if (heading.innerHTML.indexOf("&amp;") !== -1) {
      heading.innerHTML = heading.innerHTML.replace(/&amp;/g, '<span class="toa-amp">&amp;</span>');
    }
  }

  function init() {
    var handle = handleFromPath();
    var existing = document.querySelector("[data-toa-collection-hero]");
    if (existing) {
      addStyle();
      repairExistingHeroAmpersand(existing);
      var existingHandle = existing.getAttribute("data-toa-collection-hero") || handle;
      if (!DATA[existingHandle] || DATA[existingHandle].mode !== "banner") updateHeroFacts(existingHandle);
      return;
    }
    if (!DATA[handle]) return;
    render(handle, DATA[handle]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
